import { getPropsForClickTracking } from "../../utils/tracking";
<if(input.itemPillData)>
  $ const { itemPillData, filterKey, open } = input;
  $ const { options, minPriceInput, maxPriceInput, showMinError, showMaxError } = state;
  $ const { actions, title, closeOverlay } = itemPillData.filterModal;
  $ const resetAction = actions?.find(({ action }: any) => action?.name === "RESET_FILTER");
  $ const updateAction = actions?.find(({ action }: any) => action?.name === "APPLY_FILTER");
  $ const isPriceInvalid = filterKey === "price" && (showMinError || showMaxError);
  <ebay-lightbox-dialog
    open=open
    size="narrow"
    class="filter-condition-dialog"
    data-testid="filter-condition-dialog"
    a11yCloseText=closeOverlay?.accessibilityText
    on-close("emit", "close")
    ...getPropsForClickTracking(closeOverlay?.trackingList)
  >
    <@header>
      <div class="filter-condition-dialog__title" data-testid="filter-condition-dialog-title">
        <fe-textual-display model=title/>
      </div>
    </@header>

    <@footer>
      <div class="filter-condition-dialog__footer">
        <ebay-button
          data-testid="filter-condition-dialog-footer-btn-reset"
          priority="tertiary"
          on-click("handleReset")
          ...getPropsForClickTracking(resetAction?.action?.trackingList)
        >
          <fe-textual-display model=resetAction?.text/>
        </ebay-button>

        <ebay-button
          data-testid="filter-condition-dialog-footer-btn-submit"
          priority="primary"
          on-click("handleSubmit")
          disabled=isPriceInvalid
          ...getPropsForClickTracking(updateAction?.action?.trackingList)
        >
          <fe-textual-display model=updateAction?.text/>
        </ebay-button>
      </div>
    </@footer>

    <if(filterKey === "condition")>
      <filter-condition-options options=options on-option-change("onOptionChange")/>
    </if>
    <if(filterKey === "price")>
      <filter-price-options
        entries=(itemPillData.filterModal.entries)
        minValue=minPriceInput
        maxValue=maxPriceInput
        showMinError=showMinError
        showMaxError=showMaxError
        on-min-price-change("handleMinChange")
        on-max-price-change("handleMaxChange")
      />
    </if>
  </ebay-lightbox-dialog>
</if>
